<template>
  <div :class="$style.root">
    <template v-if="linkType === 'button'">
      <AtomsConsumerImage
        :class="[$style.img, { [$style.rounded]: imageRounded }]"
        :src="!minScreenMd ? spImage : pcImage"
        :alt="title ? title : imgAlt"
        :width="bannerWidth"
      />
      <div :class="$style.banner_content">
        <div :class="$style.banner_content_text">
          <p v-if="tag" :class="$style.banner_content_tag">{{ tag }}</p>
          <p v-if="title" :class="$style.banner_content_title">{{ title }}</p>
          <p v-if="description" :class="$style.banner_content_description">{{ description }}</p>
        </div>
        <AtomsConsumerLink
          :class="$style.link"
          :url="linkUrl"
          @click="trackBannerClick('top_page', linkUrl, 0, title ?? '')"
        >
          <MoleculesConsumerButtonWithArrowRight :class="$style.round_button" variant="secondary" rounded>
            {{ buttonText }}
          </MoleculesConsumerButtonWithArrowRight>
        </AtomsConsumerLink>
      </div>
    </template>

    <AtomsConsumerLink
      v-else
      :class="[$style.link, $style.full_image]"
      :url="linkUrl"
      @click="trackBannerClick('top_page', linkUrl, 0, title ?? '')"
    >
      <AtomsConsumerImage
        :class="[$style.img, { [$style.rounded]: imageRounded }]"
        :src="!minScreenMd ? spImage : pcImage"
        :alt="title ? title : imgAlt"
      />
      <div :class="$style.banner_content">
        <div :class="$style.banner_content_text">
          <p v-if="tag" :class="$style.banner_content_tag">{{ tag }}</p>
          <p v-if="title" :class="$style.banner_content_title">{{ title }}</p>
          <p v-if="description" :class="$style.banner_content_description">{{ description }}</p>
        </div>
      </div>
    </AtomsConsumerLink>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    pcImage: string
    spImage: string
    minScreenMd: boolean
    /** ボタン部分だけのリンク or 画像全体のリンク */
    linkType?: "button" | "fullImage"
    /** 画像の縁を丸める */
    imageRounded?: boolean
    tag?: string
    title?: string
    description?: string
    linkUrl?: string
    buttonText?: string
    /** 画像のalt titleを指定しない時に使用 */
    imgAlt?: string
  }>(),
  {
    linkType: "button",
    imageRounded: false,
    tag: "",
    title: "",
    description: "",
    linkUrl: "/",
    buttonText: "詳しくみる",
    imgAlt: "",
  },
)
const { trackBannerClick } = useGtagEvent()

const { width: windowWidth } = useWindowSize()
const bannerWidth = computed(() => (windowWidth.value > 768 ? 1920 / 2 : 768 - 32)) // 1920/2=半分のサイズ 768-32=paddingを除いたサイズ
</script>

<style scoped module lang="scss">
.root {
  position: relative;
  .img {
    width: 100%;
    object-fit: contain;
    @include background-skeleton-loading;
    &.rounded {
      border-radius: 0.5rem;
    }
  }
  .banner_content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    width: 95%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 40px;
    @include md {
      bottom: 7.6%;
    }
    .banner_content_text {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      align-items: center;
      color: $white;
      text-align: center;
      .banner_content_tag {
        padding: 0.25rem 0.5rem;
        border: 1px solid $white;
        font-size: $font-size-12;
        line-height: 1.7;
      }
      .banner_content_title {
        font-size: $font-size-24;
        line-height: 1.5;
        white-space: pre-line;
        @include md {
          font-size: $font-size-28;
        }
      }
      .banner_content_description {
        white-space: pre-line;
      }
    }
  }
  .link {
    &:hover {
      .round_button {
        background-color: rgba($black-10, 1);
      }
    }
    &.full_image {
      display: block;
      position: relative;
    }
    .round_button {
      border-radius: 4rem;
      padding: 0.75rem 1.25rem;
      line-height: 1;
      @include md {
        bottom: 48px;
        padding: 0.75rem 2rem;
        line-height: inherit;
      }
    }
  }
}
</style>
